import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import DivBottom from '../userNotAuth/components/divBottom'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ReactQuill from 'react-quill-new'

function EditArtistSuccess() {
    window.scrollTo(0, 0)
    const navigate = useNavigate()
    const redux = useSelector((state) => state.creaArtista.value)
    const grid = {
        display: 'grid',
        gridTemplateColumns: '21% 1fr ',
        gap: '5px'
    }
    console.log(redux)
    return (<>
        <NavbarNotAuth />
        <br /><br /><br /><br />
        <h3 className='m-3'>Profilo artista modificato con successo!</h3>
        <hr />
        <div className='container mt-3' style={{ marginBottom: '3rem' }}>
            <p className='fs-6'>
                Il tuo profilo di artista è stato modificato ma prima di essere pubblicato dovrà essere approvato
                dal nostro staff.<br />
            </p>

            <hr />
            <div style={grid}>
                <div>Nome: </div> <div>{redux.nome}</div>
                <div>Cognome: </div> <div>{redux.cognome}</div>
            </div>
            {redux.gruppo !== '' &&
                <div style={grid}>
                    <div>Gruppo: </div> <div>{redux.gruppo}</div>
                </div>
            }
            <div style={grid}>
                <div>Genere: </div> <div>{redux.genere}</div>
                <div>N. comp:</div><div>{redux.numero} {redux.numero > 1 ? 'elementi' : 'elemento'}</div>
                <div>Regione: </div> <div>{redux.regione}</div>
                <div>Città: </div> <div>{redux.città}</div>
                <div>Durata show: </div> <div>{redux.durata}</div>
                <div>Cachet: </div> <div>€ {redux.cachet}</div>
            </div>
            <div>Descrizione: </div>
            <ReactQuill className="textarea-quill"
                value={redux.descrizione}
                theme="snow"
                modules={{
                    toolbar: false
                }}
            /><br />

            {redux.telefono !== '' &&
                <div style={grid}>
                    <div>Telefono: </div> <div>{redux.telefono}</div>
                </div>
            }
            <div style={grid}>
                <div>Email: </div> <div>{redux.email}</div>
            </div>
            {redux.url !== '' &&
                <div style={grid}>
                    <div>Url: </div> <div style={{}}>{redux.url.substring(0, 35)}...</div>
                </div>
            }
            {redux.fb !== '' &&
                <div style={grid}>
                    <div>fb: </div> <div style={{}}>{redux.fb.substring(0, 35)}...</div>
                </div>
            }
            {redux.youtube !== '' &&
                <div style={grid}>
                    <div>youtube: </div> <div style={{}}>{redux.youtube.substring(0, 35)}...</div>
                </div>
            }
            {redux.foto &&
                <div className='mt-3'>
                    <p>Immmagine caricata:</p>
                    <img src={`https://leuro-bucket.s3.amazonaws.com/${redux.foto}`} width={110} height={110} alt='' />
                </div>
            }
            {redux.video &&
                <div>
                    <p className='mt-3'>VIDEO CARICATO:</p>
                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${redux.video}`} width={180} height={110} controls />
                </div>
            }
            <br />
            <div style={{ margin: '2em 0 2em 1em' }}>
                <button className='btn btn-secondary' onClick={() => {
                    navigate('/', { replace: true })
                }}>
                    ⇒ Home
                </button>
            </div>
        </div>
        <DivBottom />
    </>)
}
export default EditArtistSuccess
